import { type FC, useState } from "react";
import { useLineCount } from "./useLineCount";
import { Presentation } from "./Presentation";

export type MultiActionItem = {
  actionText: string;
  works: string[];
  isHot: boolean;
};

export type MinOneArray<T> = [T, ...T[]];

type Props = {
  multiActionInfo: MinOneArray<MultiActionItem>;
  isIconFire: boolean;
  showReadMoreButton?: boolean;
};

export const MultiActionInformationBox: FC<Props> = ({
  multiActionInfo,
  isIconFire,
  showReadMoreButton = false,
}) => {
  const [isClickedReadMoreButton, setIsClickedReadMoreButton] = useState<boolean[]>(
    multiActionInfo.map(() => false),
  );
  const [textRef, lineCount] = useLineCount(multiActionInfo[0].works[0]);

  const handleShowContent = (index: number) => {
    const updatedIsClickedReadMoreButton = [...isClickedReadMoreButton];
    updatedIsClickedReadMoreButton[index] = true;
    setIsClickedReadMoreButton(updatedIsClickedReadMoreButton);
  };

  const hasMultiWorksInfo = multiActionInfo[0].works.length >= 2;

  return (
    <Presentation
      multiActionInfo={multiActionInfo}
      isIconFire={isIconFire}
      showReadMoreButton={showReadMoreButton}
      isClickedReadMoreButton={isClickedReadMoreButton}
      hasMultiWorksInfo={hasMultiWorksInfo}
      lineCount={lineCount}
      handleShowContent={handleShowContent}
      textRef={textRef}
    />
  );
};
